// Fixture para datos de servicios tarifarios en modo desarrollo
export const serviciosTarifariosFixture = {
  ResponseCode: 200,
  ResponseDetail: "Ok",
  Result: {
    __type: "AcuerdosTarifariosServiciosResponse:#Consorcio.Transar.Entities.Common.Response",
    ProgresoGestion: {
      PorcentajeAprobados: 41.67,
      PorcentajePendientes: 58.33,
      PorcentajeRechazados: 0,
      TotalAprobados: 5,
      TotalCups: 12,
      TotalPendientes: 7,
      TotalRechazados: 0
    },
    Servicios: [
      {
        CantidadAprobados: 5,
        CantidadCups: 5,
        CantidadPendientes: 0,
        CantidadRechazados: 0,
        Encabezado: "Consideraciones Generales del encabezado",
        Id: 1381322,
        Observaciones: "Prueba: Parrafo que se visualiza al final de la tabla del servicio",
        Servicio: "LABORATORIO CLINICO"
      },
      {
        CantidadAprobados: 0,
        CantidadCups: 7,
        CantidadPendientes: 7,
        CantidadRechazados: 0,
        Encabezado: null,
        Id: 1381333,
        Observaciones: "Prueba: Parrafo que se visualiza al final de la tabla del servicio",
        Servicio: "PACIENTE CRONICO COMPLEJO"
      }
    ]
  }
};

// Fixture para respuesta de aprobación/rechazo de CUPS o servicios
export const estadoActualizacionFixture = {
  ResponseCode: 200,
  ResponseDetail: "Ok",
  Result: {
    __type: "EstadoObjetosResponse:#Consorcio.Transar.Entities.Common.Response",
    EstadoObjetos: [], // Se llenará dinámicamente
    IdsError: 0,
    IdsOk: 0 // Se llenará dinámicamente
  }
};